import { selectLoginView } from "state/slices/loginViewSlice";
// import LoginImage from "assets/images/IMS_Login.jpg";
import LoginImage from "assets/images/Ereply.png";
import { useSelector } from "react-redux";
import ChangePassword from "./forgot/ChangePassword";
import ForgotPassword from "./forgot/ForgotPassword";
import LoginPage from "./login/LoginPage";
import ResetPassword from "./forgot/ResetPassword";

const AuthLayout = () => {
  const loginActiveView = useSelector(selectLoginView);

  const renderActiveView = () => {
    switch (loginActiveView) {
      case "login":
        return <LoginPage />;
      case "forgot-password":
        return <ForgotPassword />;
      case "change-password":
        return <ChangePassword />;
      case "reset-password":
        return <ResetPassword />;
      default:
        return <LoginPage />;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-5">{renderActiveView()}</div>
        <div className="col-md-7 d-none d-md-flex justify-content-center">
          <img
            src={LoginImage}
            alt="Login_Image"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "30px",
              marginRight: "100px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
